import axios from 'axios';

// config
import { HOST_API } from '../config';
import { GOHUB_API } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

const lng = localStorage.getItem('i18nextLng');

// if (language) {
//   axiosInstance.defaults.headers.common['Accept-Language'] = language;
// }

export const getCurrentLanguage = (lng) => {
  let currentLanguage = '';

  if (lng === 'en') {
    currentLanguage = 'en-US;';
  }

  if (lng === 'pt') {
    currentLanguage = 'pt-PT;';
  }

  if (lng === 'es') {
    currentLanguage = 'es-ES;';
  }

  return currentLanguage;
};

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {

//     Promise.reject((error.response && error.response.data) || 'Something went wrong')

//   }
// );

const usersAxiosInstance = axios.create({
  baseURL: GOHUB_API,
  headers: {
    'Accept-Language': getCurrentLanguage(lng),
  },
});

usersAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong with users')
);

export default axiosInstance;
export { usersAxiosInstance };
